module.exports = __webpack_public_path__ + "79bca5d5760ae8b8e24428c282d84e81.jpg";